import React from 'react';
import { ArrowRightIcon, PlayCircleIcon } from 'lucide-react';
import { TestimonialCard } from './TestimonialCard';
interface CaseStudy {
  thumbnail: string;
  title: string;
  walkthroughTitle: string;
  url: string;
}
const caseStudies: CaseStudy[] = [{
  thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oKL2RUFhp6qkvbGFwdaDfu/pasted-image.png',
  title: 'From Chronic Pain to Pain Free - Defeating Osteoarthritis',
  walkthroughTitle: 'How We Helped Our Client Become Pain-Free and Defeat Osteoarthritis',
  url: 'https://youtu.be/226rmSgq68A?si=FvO8wygPjwdfeT8U'
}, {
  thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gCHd6t3G7ECjTaZPKrk6a6/pasted-image.png',
  title: 'Complete Upgrade in Business & Life - Total Performance Enhancement',
  walkthroughTitle: 'How We Helped Our Client Enhance Their Performance in Business and Life',
  url: 'https://youtu.be/VxilMGM7uE8?si=WPp7FEr-gy8F1snb'
}, {
  thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oJBi22my5QWSprp2dLrH7P/pasted-image.png',
  title: 'High Radial Nerve Palsy Reversed - From Wrist Drop to Full Recovery',
  walkthroughTitle: 'How We Helped Our Client Fully Recover From High Radial Nerve Palsy',
  url: 'https://youtu.be/DG-Tf01uqfk?si=4u2a-_FsTqzvzGa8'
}, {
  thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gWrdoTVTtD8tnzKrhceBmG/pasted-image.png',
  title: 'How He Escaped Dialysis & Reversed Kidney Disease',
  walkthroughTitle: 'How We Helped Our Client Escape Dialysis and Reverse Kidney Disease',
  url: 'https://youtu.be/yrF73YFikJI?si=r77xKstcDTM2PBdo'
}, {
  thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sUYNQpBzsywUhjzha6Ud1E/pasted-image.png',
  title: 'Beating "Incurable" Autoimmune Disease - Reversing Rheumatoid Arthritis',
  walkthroughTitle: 'How We Helped Our Client Reverse Rheumatoid Arthritis',
  url: 'https://youtu.be/VLAbfsKtAvo?si=0UdYOxyYJxdnf-SV'
}, {
  thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2RDUn16cxVxDMPjfP6bCVd/pasted-image.png',
  title: 'Reversing Heart Failure - No Longer Needs Heart Transplant',
  walkthroughTitle: 'How We Helped Our Client Reverse Heart Failure and Avoid a Heart Transplant',
  url: 'https://youtu.be/bmLQYGeC960?si=cGt3AQfMjNz3nBNi'
}, {
  thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3tJoDykHovRmH2SXskyd54/pasted-image.png',
  title: 'Defying Age: From Burnout to 15-Year Biological Age Reversal',
  walkthroughTitle: 'How We Helped Our Client Reverse Their Biological Age by 15 Years',
  url: 'https://youtu.be/YwEywZxMSgo?si=sxvzMNW78swQxJM8'
}, {
  thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tA6F2wb81UfvKyHq7dYXrw/pasted-image.png',
  title: 'From Cognitive Decline to Mental Superhuman',
  walkthroughTitle: 'How We Helped Our Client Reverse Cognitive Decline',
  url: 'https://youtu.be/bdFY2s3nbtM?si=ylMcP485F9gONF5x'
}, {
  thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qZ4EpkZoX599qCEfq3gNVv/pasted-image.png',
  title: "How We're Reversing Alzheimer's Disease - The Breakthrough Approach",
  walkthroughTitle: "How We Helped Our Client Reverse Alzheimer's Disease",
  url: 'https://youtu.be/TEDmmZfPIa0?si=oPFcNi7vt43c2VuT'
}];
export function CaseStudiesSection() {
  return <div className="grain-section w-full border-b-4 border-teal-100 bg-page-bg px-6 py-20 md:py-28" data-id="element-19" data-mp="1tldz2g1c1xro">
      <div className="max-w-7xl mx-auto space-y-16 md:space-y-20" data-id="element-20" data-mp="1xleb5u0ylwvk">
        <div className="mx-auto max-w-5xl space-y-8 text-center" data-id="element-21" data-mp="10wylzz1rhpiz">
          <h2 className="text-4xl font-bold leading-tight tracking-tight text-ink md:text-6xl" data-id="element-22" data-mp="15uqdiryhv9mn">
            More Examples of{' '}
            <span className="text-teal-600 underline decoration-teal-200 decoration-[7px] underline-offset-[7px]" data-id="element-23" data-mp="19vk0nj444keh">
              "Impossible" Transformations
            </span>{' '}
            We've Created for Our Clients
          </h2>

          <div className="inline-flex items-center gap-3 rounded-full border border-teal-200 bg-teal-50 px-6 py-3 shadow-sm" data-id="element-24" data-mp="2lduus90chwwz">
            <PlayCircleIcon className="h-5 w-5 text-teal-600" aria-hidden="true" data-id="element-25" data-mp="2otfwzko4t21b" />
            <span className="text-sm font-black uppercase tracking-[0.18em] text-teal-700" data-id="element-26" data-mp="2ovivkt3co3hn">
              Full Video Breakdowns
            </span>
          </div>

          <p className="mx-auto max-w-3xl text-xl font-light leading-relaxed text-ink-light" data-id="element-27" data-mp="2xvxke2fiw0pw">
            Watch these case studies and see some of our work for yourself.
            These aren't small wins. These are life-changing transformations.
            The kind conventional medicine calls "impossible."
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-28" data-mp="3hidf9nsceyu2">
          {caseStudies.map(study => <a key={study.url} href={study.url} target="_blank" rel="noopener noreferrer" className="group flex h-full flex-col overflow-hidden rounded-[2rem] border border-black/[0.07] bg-white shadow-[0_14px_40px_rgba(26,26,46,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-teal-200 hover:shadow-[0_22px_50px_rgba(2,132,199,0.12)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-teal-200" aria-label={`Watch client transformation walkthrough: ${study.walkthroughTitle}`} data-id="element-29" data-mp="3hk6b081f3yna">
              <div className="relative aspect-video flex-shrink-0 overflow-hidden" data-id="element-30" data-mp="3w5c3l9vwld4k">
                <img src={study.thumbnail} alt={study.title} width={640} height={360} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-31" data-mp="20u4w6kmxiy" />
                <span className="absolute bottom-4 right-4 flex h-11 w-11 items-center justify-center rounded-full bg-white text-teal-700 shadow-lg transition-transform duration-300 group-hover:scale-110" data-id="element-32" data-mp="3r5ph09u6qkj3">
                  <PlayCircleIcon className="h-6 w-6" aria-hidden="true" data-id="element-33" data-mp="3hfmnm8j5j4k8" />
                </span>
              </div>

              <div className="flex flex-1 flex-col p-6" data-id="element-34" data-mp="33hfyphw6kewp">
                <p className="text-[10px] font-black uppercase tracking-[0.17em] text-teal-700" data-id="element-35" data-mp="38fht2yz240nh">
                  Client Transformation Walkthrough
                </p>
                <h3 className="mt-3 text-xl font-black leading-tight text-ink transition-colors duration-300 group-hover:text-teal-700" data-id="element-36" data-mp="1e0kejnnm015i">
                  {study.walkthroughTitle}
                </h3>
                <p className="mt-5 border-t border-black/[0.06] pt-4 text-sm font-semibold text-ink-light" data-id="element-37" data-mp="149psajad51k2">
                  Watch the full video breakdown
                </p>
              </div>
            </a>)}
        </div>

        <div className="!mt-12 text-center" data-id="element-38" data-mp="1wvr8clvp1nik">
          <a href="#advanced-price" className="inline-flex w-full items-center justify-center gap-3 rounded-2xl bg-emerald-600 px-9 py-5 text-center text-base font-black text-white shadow-[0_12px_32px_rgba(5,150,105,0.3)] ring-1 ring-emerald-500 transition-all duration-200 hover:-translate-y-1 hover:bg-emerald-700 hover:shadow-[0_18px_42px_rgba(5,150,105,0.35)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-emerald-300/50 sm:w-auto sm:text-lg" data-id="element-39" data-mp="1s03o8kw2jkjx">
            Book Your Meeting With the Master: Advanced
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-40" data-mp="2j8dklwrw5ixp" />
          </a>
        </div>

        <div className="max-w-4xl mx-auto space-y-8 pt-8" data-id="element-41" data-mp="2o65dat0d192y">
          <TestimonialCard text="Update on grandparents with peptides: He just called me to update me he feels 20 years younger and she is doing yard work AND just did a 100 piece jigsaw puzzle (she's loved puzzles her whole life). 6 months ago she couldn't do a five piece jigsaw puzzle. I don't care what anyone says, peptides f**king work." highlight={true} profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/oEpan9Q2S1ziM4cjxAeF15/image.png" name="Kademlia, Transformation Services Client & Peptide Mastery Buyer" data-id="element-42" data-mp="2s6yyhemf49s5" />
          <TestimonialCard text="Increased muscle tone & strength, improved skin tone and elasticity. As well as more sharp and dialled in you can say I feel revived/revamped into my younger self it feels like, everything from my sense of smell, taste, sight, hearing and unique feeling of mind and body connection/connectivity profoundly escalated. Feels like my whole being has been enhanced." name="Rick G., Peptide Mastery buyer" data-id="element-43" data-mp="3fw9rub1fv1w9" />
        </div>
      </div>
    </div>;
}